<template>
  <div>
    <div class="ensure-plan">保障计划</div>
    <table class="ensure" cellpadding="0" cellspacing="0">
      <tr>
        <td colspan="2" style="border-bottom: none">保障责任</td>
      </tr>
      <tr>
        <td colspan="2" class="detail">
          <div>
            火灾爆炸、交通事故、货物碰撞挤压、雨淋、装卸意外、盗抢、隧道桥梁码头坍塌
            <div class="check" @click="openNotice">查看详情</div>
          </div>
        </td>
      </tr>
      <tr>
        <td>保障额度</td>
        <td>1-300万</td>
      </tr>
      <tr>
        <td>免赔额</td>
        <td>
          <div class="check" @click="Deductible">查看详情</div>
        </td>
      </tr>
      <tr>
        <td>保障期限</td>
        <td>次单，不超过15天</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { myTrack } from "../common/track";
export default {
  name: "InsPlan",
  methods: {
    openNotice() {
      this.$router.push({ name: "GuaranteeRes" });
      try {
        myTrack("bxsc_go_to_the_product_page", {
          click_coverage_details: "点击保障责任-查看详情",
        });
      } catch (error) {
        window.console.log(error);
      }
    },
    Deductible() {
      this.$router.push({ name: "Deductible" });
      try {
        myTrack("bxsc_go_to_the_product_page", {
          click_deductible_details: "点击免赔额-查看详情",
        });
      } catch (error) {
        window.console.log(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ensure-plan {
  height: 12vw;
  padding-left: 10.67vw;
  margin-top: 2.67vw;
  line-height: 12vw;
  text-align: left;
  font-size: 4.27vw;
  font-weight: bold;
  background: url(../assets/ensure_plan.png) no-repeat 5.33vw center #ffffff;
  background-size: 4vw;
}
.ensure {
  width: 100%;
  background: #ffffff;
  tr {
    height: 13.33vw;
    line-height: 13.33vw;
    td {
      border-bottom: 0.27vw solid #f5f5f9;
    }
    td:nth-child(1) {
      padding-left: 5.33vw;
      text-align: left;
      color: #333333;
      min-width: 32vw;
    }
    td:nth-child(2) {
      padding-right: 5.33vw;
      font-size: 3.73vw;
      text-align: right;
      color: #999999;
      line-height: 8vw;
    }
  }
  .detail {
    padding-right: 5.33vw;
    font-size: 3.73vw;
    text-align: right;
    color: #999999 !important;
    line-height: 6vw;
    .check {
      float: right;
    }
    &:after {
      clear: both;
    }
  }
  .check {
    max-width: 72.8vw;
    padding-right: 4.53vw;
    color: #3385ff;
    background: url(../assets/right.png) no-repeat right center;
    background-size: 1.33vw;
  }
}
</style>
